import { render, staticRenderFns } from "./VatCalculator.vue?vue&type=template&id=25b44b92&scoped=true&"
import script from "./VatCalculator.vue?vue&type=script&lang=js&"
export * from "./VatCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b44b92",
  null
  
)

export default component.exports